import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { Volume4Preview } from './components/Volume4Preview';
import { askedFor, fromTheDock, everySeason, instructorReviews } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-navy selection:bg-lav-soft selection:text-navy" data-id="element-0" data-mp="3ihuyk4ft23e4">
      <MetaPixel data-id="element-1" data-mp="3rc9e8848zfxr" />
      <main data-id="element-2" data-mp="3rbrakqf99zft">
        <Hero data-id="element-3" data-mp="3rbzq6q2rjiup" />
        <SocialProofBar data-id="element-4" data-mp="3rdkg22e4udm8" />
        <PainGrid data-id="element-5" data-mp="3recdzjv7cnfo" />
        <ProductReveal data-id="element-6" data-mp="5yj0slx59ec" />
        <Tomes data-id="element-7" data-mp="6htjo98ovic" />
        <Bonuses data-id="element-8" data-mp="4ww9qvjiygs" />
        <Volume4Preview data-id="element-9" data-mp="5ggxfcks0yi" />
        <Testimonials testimonials={instructorReviews} eyebrow="From instructors using the pack" title="What instructors are saying" background="white" data-id="element-10" data-mp="7ssnarqpf34" />
        <Testimonials testimonials={fromTheDock} eyebrow="Straight from the dock" title="The day the wind breaks the plan" subtitle="Public comments from sailing instructors and sailing organizations about teaching around the weather. They are not reviews of this pack: they are the problem it was built to solve." background="blush" data-id="element-11" data-mp="33oi152avuyvf" />
        <ValueStack data-id="element-12" data-mp="swgk5o3310p4" />
        <Urgency data-id="element-13" data-mp="36877lhgoowl" />
        <Pricing data-id="element-14" data-mp="35oxgs1yt6tn" />
        <Testimonials testimonials={askedFor} eyebrow="We read the research first" title="What programs expect from instructors" subtitle="Before writing a single Lesson Card, we read what clubs, schools and sailing organizations say instructors need. These are public comments, not reviews of this pack. Every volume was built to answer them." background="white" data-id="element-15" data-mp="356s95xbri9l" />
        <Guarantee data-id="element-16" data-mp="3gja6a20us6ff" />
        <Faq data-id="element-17" data-mp="3bmbehq4nwbke" />
        <Testimonials testimonials={everySeason} eyebrow="And what happens every season" title="New staff, new weather, the same scramble" subtitle="More public comments from the sailing world. This is the gap the Any-Wind Lesson System closes." background="blush" data-id="element-18" data-mp="3bmjo995hn0rd" />
        <CostOfInaction data-id="element-19" data-mp="2xtv7ke8n3te7" />
        <Close data-id="element-20" data-mp="2xt287yc0g663" />
      </main>
      <Footer data-id="element-21" data-mp="2svto3s7axs27" />
      <PurchaseNotifications data-id="element-22" data-mp="2sw24hu2mvfi5" />
    </div>;
}